import { GeoJSON, Pane } from "react-leaflet";
import type { FeatureCollection } from "geojson";
import { LEZ_COLOR } from "src/config";
import type { PredefinedLEZ } from "src/types";

interface Props {
  predefinedLEZs: PredefinedLEZ[];
  opacity: number;
}

export function PredefinedLEZsOnMap(props: Props) {
  const { predefinedLEZs, opacity } = props;

  const featureColl: FeatureCollection = {
    type: "FeatureCollection",
    features: predefinedLEZs?.map((lez) => lez.geom) ?? [],
  };

  return (
    <Pane name="predefined-lezs">
      <GeoJSON
        data={featureColl}
        style={{ color: LEZ_COLOR, opacity: opacity, fillOpacity: 0.2 * opacity }}
        pmIgnore={true}
      />
    </Pane>
  );
}
